import { useLingui } from '@lingui/react'

import type { I18nLanguage } from '@twistopayments/design-system/base'
import { getFormattedDate } from '@twistopayments/design-system/utils'

type Props = {
  date: Parameters<typeof getFormattedDate>[0]
} & Parameters<typeof getFormattedDate>[2]

export const FormattedDate = ({ date, ...options }: Props) => {
  const {
    i18n: { locale },
  } = useLingui()

  return <>{getFormattedDate(date, locale as I18nLanguage, options)}</>
}
